import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ControlPoint, LockOpenSharp, LockSharp } from "@material-ui/icons";
import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn";
import CropRotateIcon from "@material-ui/icons/CropRotate";
import HistoryIcon from "@material-ui/icons/History";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import { ENABLE_HISTORY } from "app/appConfig";
import TableComponent from "app/common/Component/Table/TableComponent";
import IconMedicalHistory from "app/common/Icon/EyeTestTabs/IconMedicalHistory";
import IconDelete from "app/common/Icon/IconDelete";
import IconEye from "app/common/Icon/IconEye";
import IconPen from "app/common/Icon/IconPen";
import { ACTIVE_STATUS, LOCKED_STATUS } from "app/common/LocalConst";
import {
  checkPaymentMethodLimits,
  formatMoney,
  formatNumber,
  getDateTime,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleManualExchange,
  isRoleTechician,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const ListRegisterProduct = () => {
  const { t } = useTranslation();
  const {
    handleOpenCreateOrEditCardPopup,
    handleChangeFormSearchProduct,
    pageRegisterProduct,
    searchRegisterProduct,
    handleOpenConfirmDelete,
    setSelectedProductOrders,
    resetSlected,
    handleOpenListStoreRequestItemPopup,
    handleOpenReturnProductPopup,
    handleOpenProductHistoryPopup,
    setSelectProductOrderId,
    handleOpenChangeProductPopup,
    handleOpenConfirmUnlock,
    handleOpenConfirmlock,
    handleOpenHistoryProductPopup,
  } = useStore().patientManagementStore.registerProductStore;
  const {
    handleOpenPaymentVoucherPopup,
    handleOpenTotalBillStatusInvoiceItemConfirm,
    handleOpenFormLockRetaind,
  } = useStore().feeStore.serviceFeeTabStore;

  const {
    initialPatient,
    customerSourceWalkIn,
    handleOpenHistoryStaffRevenuePopup,
  } = useStore().patientManagementStore.patientGeneralStore;

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isReadonly = isRoleHisReadOnly();
  let isAdminPermission = isAdmin();

  const isRoleCashierPermission = isRoleCashier();
  const isRoleBranchManagerPermission = isRoleBranchManager();
  const isSalesConsultantPermission = isSalesConsultant();
  const isAdmins = isAdmin();
  const isDoctors = isDoctor();
  const isAccountant = isRoleHisAccountant();

  const hasAddPermission =
    isAdmins ||
    isRoleCashierPermission ||
    isAccountant ||
    isRoleBranchManagerPermission;
  const isManualExchange = isRoleManualExchange();
  const canManualExchange = isAdmins || isManualExchange;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const { handleOpenPopupHistoryChangeRemain } =
    useStore().feeStore.historyChangeRemainTabStore;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const location = useLocation();
  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";
  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body pt-0 mt-2"
      style={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid item xs={12}>
        <TableComponent
          showOrdinalNumbers
          titleNodata={t("noData")}
          data={pageRegisterProduct?.content || []}
          name="ListRegisterProduct"
          showMoreButton
          allowHorizontalScroll
          resetSelectedRows={resetSlected}
          selectType={!isReadonly ? "multi" : undefined}
          handleChangeSelectedRows={setSelectedProductOrders}
          columns={[
            ...(!isInDetailPage
              ? [
                {
                  title: t("Tạo phiếu chi"),
                  field: "action",
                  width: "70px",
                  render: (row) => {
                    //console.log("🚀 ~ row:", row);
                    return (
                      <div className="flex-center gap-2">
                        {hasAddPermission && (
                          <>
                            <Tooltip title={"Tạo phiếu chi"}>
                              <div
                                onClick={() => {
                                  if (!isReadonly) {
                                    let staffRevenues =
                                      row?.staffRevenues?.map((el) => ({
                                        ...el,
                                        id: null,
                                      }));

                                    handleOpenPaymentVoucherPopup(
                                      initialPatient?.patientInfo,
                                      null,
                                      customerSourceWalkIn,
                                      {
                                        drugOrder: row,
                                        totalAmount:
                                          row?.totalBillPatientPaid || 0,
                                        staffRevenues: staffRevenues,
                                      }
                                    );
                                  }
                                }}
                                className="mr-1 flex"
                              >
                                <ControlPoint
                                  style={{
                                    color: "#3f51b5",
                                    fontSize: "22px",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    );
                  },
                },
              ]
              : []),
            hasAddPermission && {
              title: t("action"),
              field: "action",
              align: "center",
              width: "70px",
              render: (row) => {
                const isLocked = row?.activeStatus === LOCKED_STATUS;
                const canShowChangeService = !isLocked && canManualExchange;
                return (
                  <div className="flex-center gap-2">
                    {!isReadonly && (
                      <>
                        <div className="flex-center gap-2">
                          <Tooltip
                            title={
                              row?.activeStatus === LOCKED_STATUS
                                ? "Sản phẩm đã bị khóa - không thể chỉnh sửa"
                                : "Chỉnh sửa"
                            }
                          >
                            <div
                              onClick={
                                !isLocked
                                  ? () =>
                                    handleOpenCreateOrEditCardPopup({
                                      ...row,
                                      isDisabled: false,
                                    })
                                  : undefined
                              }
                              style={{
                                cursor: isLocked ? "not-allowed" : "pointer",
                                opacity: isLocked ? 0.5 : 1,
                              }}
                            >
                              <IconPen />
                            </div>
                          </Tooltip>
                          <Tooltip
                            title={
                              row?.activeStatus === LOCKED_STATUS ||
                                row?.exportedQuantity > 0
                                ? "Sản phẩm đã bị khóa - không thể xóa"
                                : "Xóa"
                            }
                          >
                            <div
                              className="flex"
                              onClick={
                                row?.activeStatus !== LOCKED_STATUS &&
                                  (!row?.exportedQuantity ||
                                    row?.exportedQuantity <= 0)
                                  ? () => handleOpenConfirmDelete(row?.id)
                                  : undefined
                              }
                              style={{
                                cursor:
                                  row?.activeStatus === LOCKED_STATUS ||
                                    row?.exportedQuantity > 0
                                    ? "not-allowed"
                                    : "pointer",
                                opacity:
                                  row?.activeStatus === LOCKED_STATUS ||
                                    row?.exportedQuantity > 0
                                    ? 0.5
                                    : 1,
                              }}
                            >
                              <IconDelete />
                            </div>
                          </Tooltip>
                          {(row?.exportedQuantity || 0) -
                            (row?.refundedQuantity || 0) >
                            0 && (
                            <Tooltip title="Hoàn trả">
                              <div
                                className="flex"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleOpenReturnProductPopup(row)
                                }
                              >
                                <AssignmentReturnIcon
                                  style={{
                                    color: "#e67e22",
                                    fontSize: "22px",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          )}
                          <Tooltip title="Tùy chọn">
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, row)}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <Menu
                          anchorEl={anchorEl}
                          keepMounted
                          open={
                            Boolean(anchorEl) && selectedRow?.id === row?.id
                          }
                          onClose={handleMenuClose}
                          PaperProps={{
                            style: {
                              boxShadow: "none",
                            },
                          }}
                        >
                          {!isLocked && (
                            <MenuItem>
                              <Tooltip title={"Khóa"}>
                                <div
                                  onClick={() => {
                                    handleOpenConfirmlock(row?.id);
                                    handleMenuClose();
                                  }}
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockSharp
                                    style={{
                                      color: "#3f51b5",
                                      fontSize: "22px",
                                    }}
                                  />
                                  <span>Khóa</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}
                          {!isLocked && (
                            <MenuItem>
                              <Tooltip title={"Khóa và lưu trữ số dư"}>
                                <div
                                  onClick={() => {
                                    handleOpenFormLockRetaind(row);
                                    handleMenuClose();
                                  }}
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockSharp
                                    style={{
                                      color: "#3f51b5",
                                      fontSize: "22px",
                                    }}
                                  />
                                  <span>Khóa và lưu trữ số dư</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}

                          {isLocked && (
                            <MenuItem>
                              <Tooltip title={"Mở khóa"}>
                                <div
                                  onClick={() => {
                                    handleOpenConfirmUnlock(row?.id);
                                    handleMenuClose();
                                  }}
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockOpenSharp
                                    style={{
                                      color: "#3f51b5",
                                      fontSize: "22px",
                                    }}
                                  />
                                  <span>Mở khóa</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}
                          <MenuItem>
                            <Tooltip title={"Xem chi tiết sản phẩm"}>
                              <div
                                onClick={() => {
                                  handleOpenCreateOrEditCardPopup({
                                    ...row,
                                    isDisabled: true,
                                  });
                                  handleMenuClose();
                                }}
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <IconEye />
                                <span>Xem chi tiết</span>
                              </div>
                            </Tooltip>
                          </MenuItem>
                          {ENABLE_HISTORY && (
                            <MenuItem>
                              <Tooltip title={"Lịch sử"}>
                                <div
                                  className="flex"
                                  onClick={() => {
                                    setSelectProductOrderId(row?.id);
                                    handleOpenProductHistoryPopup(); // <- thêm dấu ngoặc để gọi hàm
                                  }}
                                >
                                  <HistoryIcon />
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}
                          {canShowChangeService && (
                            <MenuItem>
                              <Tooltip title="Đổi sản phẩm">
                                <div
                                  onClick={() => {
                                    handleOpenChangeProductPopup(row, initialPatient?.patientInfo,);
                                    handleMenuClose();
                                  }}
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <SyncAltIcon color="primary" />
                                  <span>Đổi sản phẩm</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}

                          {isAdminPermission && row?.currentInvoiceItemId && (
                            <MenuItem>
                              <Tooltip
                                title={
                                  "Tính số tiền và cập nhật trạng thái thanh toán "
                                }
                              >
                                <div
                                  onClick={() => {
                                    handleOpenTotalBillStatusInvoiceItemConfirm(
                                      row?.currentInvoiceItemId
                                    );
                                    handleMenuClose();
                                  }}
                                  className="flex gap-1 align-center"
                                >
                                  <CropRotateIcon color="primary" />
                                  <span>
                                    Tính số tiền và cập nhật trạng thái thanh
                                    toán{" "}
                                  </span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}
                          <MenuItem
                            title="Xem lịch sử sản phẩm"
                            onClick={() => {
                              handleOpenHistoryProductPopup({
                                patient: initialPatient?.patientInfo,
                                id: row?.id,
                              });
                              handleMenuClose();
                            }}
                          >
                            <div className="flex gap-1 align-center">
                              <IconMedicalHistory
                                color="blue"
                                style={{ width: "18px", marginRight: 8 }}
                              />
                            </div>
                            <span>Xem lịch sử sản phẩm</span>
                          </MenuItem>

                          <MenuItem>
                            <Tooltip
                              title="Xem lịch sử phân bổ"
                              onClick={() => {
                                handleMenuClose();
                                handleOpenHistoryStaffRevenuePopup({
                                  // id:row?.id,
                                  drugOrderId: row?.id,
                                });
                              }}
                            >
                              <div className="flex gap-1 align-center">
                                <IconMedicalHistory
                                  style={{ width: "18px", marginRight: 8 }}
                                  color="blue"
                                />
                                <span>Xem lịch sử phân bổ</span>
                              </div>
                            </Tooltip>
                          </MenuItem>

                          <MenuItem>
                            <Tooltip
                              title="Xem lịch sử phân chuyển đổi số dư"
                              onClick={() => {
                                handleMenuClose();
                                handleOpenPopupHistoryChangeRemain({
                                  patientId,
                                  invoiceItemId: row?.currentInvoiceItemId,
                                });
                              }}
                            >
                              <div className="flex gap-1 align-center">
                                <IconMedicalHistory
                                  style={{ width: "21px", marginRight: 8 }}
                                  color="blue"
                                />
                                <span>Xem lịch sử phân chuyển đổi số dư</span>
                              </div>
                            </Tooltip>
                          </MenuItem>
                        </Menu>
                      </>
                    )}
                  </div>
                );
              },
            },
            {
              title: t("Mã đơn hàng"),
              field: "code",
            },
            {
              field: "clientCard.name",
              title: t("Tên sản phẩm"),
              render: (val) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    className="service-name"
                    style={{
                      cursor:
                        !isReadonly && !val?.treatmentPlanCard
                          ? "pointer"
                          : "not-allowed",
                    }}
                    onClick={
                      !isReadonly && !val?.treatmentPlanCard
                        ? () => handleOpenCreateOrEditCardPopup(val)
                        : undefined
                    }
                  >
                    {checkPaymentMethodLimits()
                      ? val?.drug?.registeredName || val?.drugName
                      : val?.drugName}
                  </span>
                  <i>
                    <span>
                      <Tooltip title="Đã thu">
                        <b style={{ color: "green" }}>
                          {formatMoney(+val?.totalBillPatientPaid || 0)}
                        </b>
                      </Tooltip>
                    </span>
                    /
                    <span>
                      <Tooltip title="Cần thu">
                        <b style={{ color: "red" }}>
                          {formatMoney(val?.amountActuallyPaid || 0)}
                        </b>
                      </Tooltip>
                    </span>
                  </i>
                </div>
              ),
            },
            {
              field: "totalAmount",
              title: "Giá tiền",
              align: "right",
              render: (val) => formatMoney(val?.totalAmount),
            },
            {
              field: "soldQuantity",
              title: t("Số lượng"),
              align: "right",
            },
            {
              field: "percentDiscount",
              title: t("% giảm giá"),
              render: (val) =>
                val?.treatmentPlanCard ? "" : val?.percentDiscount,
              align: "right",
            },
            {
              field: "exportedQuantity",
              title: t("SL đã xuất"),
              align: "center",
              render: (val) => (
                <span
                  className="text-decoration"
                  onClick={() => handleOpenListStoreRequestItemPopup(val?.id)}
                >
                  {val?.exportedQuantity}
                </span>
              ),
            },
            {
              field: "refundedQuantity",
              title: t("SL đã hoàn"),
              align: "center",
              render: (val) =>
                val?.refundedQuantity > 0 ? (
                  <span style={{ color: "#e67e22" }}>
                    {val?.refundedQuantity}
                  </span>
                ) : (
                  ""
                ),
            },
            {
              field: "practitioner.staffName",
              title: t("Thành tiền"),
              width: "240px",
              render: (data) => {
                return (
                  <div className="total-data-group">
                    <div className="flex justify-between">
                      Tổng tiền: <b>{formatMoney(data?.totalAmount)}</b>
                    </div>
                    <div className="flex justify-between">
                      Giảm giá: <b>{formatMoney(data?.discount)}</b>
                    </div>

                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Số tiền (sau giảm):{" "}
                        <b>
                          {formatMoney(
                            data?.totalAmount - (+data?.discount || 0)
                          )}
                        </b>
                      </b>
                    </div>
                    <div className="flex justify-between">
                      Tiền khấu trừ: <b>{formatMoney(+data?.oldCredit || 0)}</b>
                    </div>
                    {data?.allocateDiscount ? (
                      <div>
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Giảm tổng HĐ:{" "}
                          <b>{formatMoney(data?.allocateDiscount)}</b>
                        </b>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div
                      style={{
                        background: "#ccc",
                        width: "100%",
                        height: "1px",
                        margin: "4px 0",
                      }}
                    ></div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Tổng thanh toán:{" "}
                        <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                      </b>
                    </div>
                  </div>
                );
              },
            },
            {
              field: "clientCard.name",
              title: t("Doanh thu phân bổ(nhân viên)"),
              width: "300px",
              render: (val) => {
                return (
                  <>
                    {val?.staffRevenues?.map((staffRevenue, index) => (
                      <div
                        key={index}
                        className="revenue-item"
                        style={{
                          display: "flex",
                          fontSize: isMobile ? 12 : 14,
                          marginBottom: 6,
                          padding: "4px 0",
                          borderBottom: "1px solid gray",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {staffRevenue?.source && (
                            <span className="revenue-percent">
                              {staffRevenue?.source?.name} -{" "}
                            </span>
                          )}
                          {staffRevenue?.position && (
                            <span className="position">
                              {" "}
                              {staffRevenue?.position?.name} -{" "}
                            </span>
                          )}
                        </div>
                        <div>
                          <b className="staff-name">
                            {staffRevenue?.staff?.staffName}
                          </b>
                          <i className="revenue-percent">
                            {staffRevenue?.actualAmount
                              ? `${formatMoney(
                                staffRevenue?.actualAmount
                              )} - ${formatNumber(
                                staffRevenue?.percentRevenue
                              )}%`
                              : `${formatNumber(
                                staffRevenue?.percentRevenue
                              )}%`}
                          </i>
                        </div>
                      </div>
                    ))}
                  </>
                );
              },
            },
            {
              field: "clientCard.name",
              title: t("Liệu trình"),
              render: (val) => val?.treatmentPlanCard?.clientCard?.name,
            },
            {
              field: "usedUnit.name",
              title: t("Đơn vị tính"),
            },
            {
              field: "clientCard.name",
              title: t("Ngày đăng ký"),
              render: (val) => getDateTime(val?.orderDate),
            },
            {
              field: "createdBy",
              title: t("Người tạo"),
            },
            {
              field: "modifiedBy",
              title: t("Người sửa"),
            },
            {
              field: "department.name",
              title: t("Cơ sở"),
            },
            // {
            //   field: "patient",
            //   title: t("Nguồn"),
            //   render: (row) => {
            //     const sourceName = row?.source?.name;
            //     const sourceDetailName = row?.sourceDetail?.name;
            //     return (
            //       <>
            //         <div>
            //           <div>
            //             {sourceName ? `Nguồn hiện tại: ${sourceName}` : ""}
            //           </div>
            //           <div>
            //             {sourceDetailName
            //               ? `Nguồn chi tiết: ${sourceDetailName}`
            //               : ""}
            //           </div>
            //         </div>
            //       </>
            //     );
            //   },
            // },
            {
              field: "activeStatus",
              title: t("Trạng thái"),
              render: (row) => (
                <div style={{ textAlign: "center" }}>
                  {row?.activeStatus === ACTIVE_STATUS ? (
                    <Tooltip title="Đang mở">
                      <LockOpenIcon />
                    </Tooltip>
                  ) : row?.activeStatus === LOCKED_STATUS ? (
                    <Tooltip title="Đã khóa">
                      <LockIcon />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {row?.cancelAmount != null && (
                    <div className="service-name " style={{ fontSize: "10px" }}>
                      {" "}
                      Số tiền chốt khi hủy:{formatMoney(row?.cancelAmount)}
                    </div>
                  )}
                </div>
              ),
            },
            {
              field: "note",
              title: t("Ghi chú"),
            },
            {
              field: "retainedAmount",
              title: t("Số dư"),
              render: (val) => formatMoney(val?.retainedAmount),
            },
            {
              field: "createDate",
              title: t("Ngày tạo hệ thống"),
              render: (val) => getDateTime(val?.createDate),
            },
            {
              field: "oldPatientServiceRegister",
              title: t("DV/SP cũ"),
              render: (val) =>
                val?.oldPatientServiceRegister?.name || val?.oldDrugOrder?.name,
            },
            {
              title: t("Mã đơn hàng cũ"),
              field: "codeOld",
              width: "50px",
              render: (val) =>
                val?.oldDrugOrder?.code ||
                val?.oldPatientServiceRegister?.code ||
                val?.treatmentPlanCard?.oldTreatmentPlanCard?.code,
            },
          ].filter(Boolean)}
          dataPagination={{
            pageIndex: searchRegisterProduct?.pageIndex,
            pageSize: searchRegisterProduct?.pageSize,
            totalElements: pageRegisterProduct?.totalElements,
            totalPages: pageRegisterProduct?.totalPages,
            setPageIndex: (pageIndex) =>
              handleChangeFormSearchProduct({ pageIndex }),
            setPageSize: (pageSize) =>
              handleChangeFormSearchProduct({ pageSize }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListRegisterProduct));
